import React from 'react';
import { Trans } from 'react-i18next';

import { getWebBoosterVairant } from '../../../constants/webBoosterType';
import useLocale from '../../../hooks/useLocale';
import { Space } from '../../../models/SpaceStore';
import { WebBoosterType } from '../../../models/UserStore';
import { humanReadable } from '../../../utils/number';
import { JoyajoyImage } from '../JoyajoyImage';
import { SvgIcon } from '../SVGIcon';

import styles from './ClubViewCard.module.css';

type ClubViewCardProps = {
  space: Space;
  webBoosterType: WebBoosterType | undefined;
  width?: number;
  height?: number;
  backgroundColor?: string;
  onClick?: () => void;
};

export const ClubViewCard: React.FC<ClubViewCardProps> = ({
  space,
  webBoosterType,
  width,
  height,
  backgroundColor,
  onClick,
}) => {
  const l = useLocale();
  const playCount = space?.statistics?.playCount ?? 0;
  // const memberTotalCount = space?.memberTotal ?? 0;

  const spaceIconSource = space?.icon?.publicUrls?.small ?? '';

  const classroomInfo = l(space.i18nClassroomInfo);

  return (
    <div
      onClick={onClick}
      className={styles.card}
      style={{ width: width, height, backgroundColor: backgroundColor }}
    >
      <div className={styles.imageWrapper}>
        <JoyajoyImage
          resource={{ uri: spaceIconSource }}
          className={styles.image}
        />
        {space.isHome ? (
          <div className={styles.boosterContainer}>
            <div className={styles.boosterBackground}>
              <SvgIcon
                name={getWebBoosterVairant(webBoosterType).icon}
                className={styles.boosterIcon}
              />
            </div>
          </div>
        ) : null}
      </div>
      <div className={styles.infoContainer}>
        <div className={styles.spaceName}>{classroomInfo.name}</div>
        <div className={styles.subtitle}>{classroomInfo.shortDescription}</div>

        {height && <div className={styles.spacer} />}
        <div className={styles.info}>
          {/* {t('{playsCount} Plays・{followerCount} Followers', {
            playsCount: humanReadable(playCount),
            followerCount: memberTotalCount,
          })} */}

          <Trans
            i18nKey="{count} Plays"
            values={{
              count: humanReadable(playCount),
            }}
          />
        </div>
      </div>
    </div>
  );
};
